export enum DimensionOrientationMode {
	Standard = 'Standard',
	Level = 'Level'
}
